import styled, { keyframes, css } from "styled-components";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(147, 62, 197, 0.5);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(147, 62, 197, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(147, 62, 197, 0);
  }
`;

export const Text = styled.div`
  p {
    margin: 0;
  }
`;

export const Title = styled.span``;

export const Span = styled.span``;

export const Img = styled.img`
  width: 84px;
  margin: 10px 0;

  @media (max-width: 1050px) {
    width: 60px;
  }
  @media (max-width: 630px) {
    width: 60px;
    position: absolute;
    margin: 0;
    top: -34px;
    right: -1px;
    transform: rotate(90deg);
  }
`;

export const YearCardRoot = styled.a<{
  isActive: boolean;
  isReversed: boolean;
}>`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;

  font-size: 20px;
  color: black;
  transform: ${({ isReversed }) =>
    isReversed
      ? "translateY(calc(-50% + 53px))"
      : "translateY(calc(50% - 53px))"};
  text-decoration: none;

  ${Img} {
    order: ${({ isReversed }) => (isReversed ? 1 : 0)};
  }

  ${Text} {
    display: flex;
    flex-direction: column;
    align-items: center;
    order: ${({ isReversed }) => (isReversed ? 0 : 1)};
  }

  ${Span} {
    line-height: 30px;
  }

  ${Title} {
    font-size: 50px;
    font-family: StolzlMedium;
    letter-spacing: 2px;
    line-height: 60px;

    transition: 0.3s;
    backface-visibility: hidden;

    @media (max-width: 1050px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  :hover {
    ${Title} {
      transform: scale(1.1);
    }

    :after {
      clip-path: ${(props) =>
        props.isActive ? "circle(100%)" : "circle(100%)"};
      animation: ${pulse} 2s infinite;
    }
  }
  ::after {
    content: "";

    position: absolute;
    left: ${({ isActive, isReversed }) =>
      isActive
        ? "calc(50% - 13px)"
        : isReversed
        ? "calc(50% - 11px)"
        : "calc(50% - 13px)"};
    top: ${({ isReversed }) => (isReversed ? "auto" : "41px")};
    bottom: ${({ isReversed }) => (isReversed ? "40px" : "auto")};

    display: block;
    width: 24px;
    height: 24px;

    background-color: #933ec5;
    box-shadow: 0 0 0 0 rgba(147, 62, 197, 0.5);

    border-radius: 50%;
    clip-path: circle(0%);
    transition: clip-path 0.5s ease;
  }

  @media (max-width: 1050px) {
    margin: 0;
    transform: ${({ isReversed }) =>
      isReversed
        ? "translateY(calc(-50% + 40px))"
        : "translateY(calc(50% - 40px))"};

    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0px;

    ::after {
      top: 32px;
      ${({ isReversed }) => (isReversed ? "32px" : "auto")};
      left: calc(50% - 8px);
    }

    :hover {
      :after {
        width: 16px;
        height: 16px;
      }
    }
  }

  @media (max-width: 630px) {
    flex-direction: row;
    align-items: flex-start;
    width: 50%;
    transform: none;
    margin: 0;

    align-self: ${({ isReversed }) => (isReversed ? "flex-end" : "auto")};
    justify-content: ${({ isReversed }) =>
      isReversed ? "flex-end" : "flex-start"};

    ${Title} {
      margin-top: 10px;
    }

    ${Text} {
      align-items: ${({ isReversed }) =>
        isReversed ? "flex-end" : "flex-start"};
    }

    ::after {
      left: auto;
      right: -8px;
      top: ${({ isReversed }) => (isReversed ? "18" : "16px")};
    }
  }
  @media (max-width: 425px) {
    ${Text} {
      font-size: 14px;
    }
  }

  ${Img} {
    ${({ isReversed }) =>
      isReversed &&
      css`
        transform: rotate(180deg);

        @media (max-width: 630px) {
          transform: rotate(270deg);
          left: -1px;
        }
      `}
  }
`;
